import type { Locale } from './types';

const LOCALE_TAG: Record<Locale, string> = { es: 'es-CO', en: 'en-US' };

export function formatMonthYear(iso: string, locale: Locale): string {
  return new Date(iso).toLocaleDateString(LOCALE_TAG[locale], {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatFullDate(iso: string, locale: Locale): string {
  return new Date(iso).toLocaleDateString(LOCALE_TAG[locale], {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatDateRange(
  start: string,
  end: string | null,
  locale: Locale,
  presentLabel: string
): string {
  const from = formatMonthYear(start, locale);
  const to = end ? formatMonthYear(end, locale) : presentLabel;
  return from === to ? from : `${from} — ${to}`;
}

export function formatNumber(value: number, locale: Locale): string {
  return value.toLocaleString(LOCALE_TAG[locale]);
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/** Joins class names, dropping falsy values. */
export function cx(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}
